<span *ngIf="!iconType || iconType == _iconType.BondProIcon" class="bpi-icon {{bpIcon }} {{Size}}"></span>

<span *ngIf="iconType == _iconType.MaterialIcon">
  <i class="bp-mat-icon material-icons {{Size}}">{{bpIcon}}</i>
</span>
